import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      // 仪表板
      path: '/',
      name: 'dashBoard',
      meta: {
        menu: '/'
      },
      component: resolve => require(['@/pages/dashBoard'], resolve)
    },
    {
      // 报案
      path: '/report',
      name: 'report',
      meta: {
        menu: '/report',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/report'], resolve)
    },
    {
      // 新建报案
      path: '/reportAdd',
      name: 'reportAdd',
      meta: {
        menu: '/report'
      },
      component: resolve => require(['@/pages/report/detail'], resolve)
    },
    {
      // 报案修改
      path: '/reportUpdate',
      name: 'reportUpdate',
      meta: {
        menu: '/report'
      },
      component: resolve => require(['@/pages/report/detail'], resolve)
    },
    {
      // 案件受理
      path: '/receiving',
      name: 'receiving',
      meta: {
        menu: '/receiving',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/receiving'], resolve)
    },
    {
      // 案件受理——申请
      path: '/receivingApply/:step',
      name: 'receivingApply',
      meta: {
        menu: '/receiving'
      },
      component: resolve => require(['@/pages/receiving/detail'], resolve)
    },
    {
      // 案件受理——新建
      path: '/receivingAdd/:step',
      name: 'receivingAdd',
      meta: {
        menu: '/receiving'
      },
      component: resolve => require(['@/pages/receiving/detail'], resolve)
    },
    {
      // 立案
      path: '/setup',
      name: 'setup',
      meta: {
        menu: '/setup',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/setup'], resolve)
    },
    {
      // 立案申请
      path: '/setupApply',
      name: 'setupApply',
      meta: {
        menu: '/setup'
      },
      component: resolve => require(['@/pages/setup/detail'], resolve)
    },
    {
      // 理算
      path: '/adjustment',
      name: 'adjustment',
      meta: {
        menu: '/adjustment',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/adjustment'], resolve)
    },
    {
      // 理算申请
      path: '/adjustmentApply',
      name: 'adjustmentApply',
      meta: {
        menu: '/adjustment'
      },
      component: resolve => require(['@/pages/adjustment/detail'], resolve)
    },
    {
      // 签批
      path: '/sign',
      name: 'sign',
      meta: {
        menu: '/sign',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/sign'], resolve)
    },
    {
      // 签批申请
      path: '/signApply',
      name: 'signApply',
      meta: {
        menu: '/sign'
      },
      component: resolve => require(['@/pages/sign/detail'], resolve)
    },
    {
      // 调查
      path: '/research',
      name: 'research',
      meta: {
        menu: '/research'
      },
      component: resolve => require(['@/pages/research'], resolve)
    },
    {
      // 案件撤销
      path: '/repeal',
      name: 'repeal',
      meta: {
        menu: '/repeal'
      },
      component: resolve => require(['@/pages/repeal'], resolve)
    },
    {
      // 理赔查询
      path: '/claim',
      name: 'claim',
      meta: {
        menu: '/claim',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/claim'], resolve)
    },
    {
      // 理赔查询——详情
      path: '/claimDeatil',
      name: 'claimDeatil',
      meta: {
        menu: '/claim'
      },
      component: resolve => require(['@/pages/claim/detail'], resolve)
    },
    {
      // 理赔打印
      path: '/print',
      name: 'print',
      meta: {
        menu: '/print',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/print'], resolve)
    },
    {
      // 理赔打印-详情
      path: '/printDeatil',
      name: 'printDeatil',
      meta: {
        menu: '/print'
      },
      component: resolve => require(['@/pages/print/detail'], resolve)
    },
    {
      // 影像管理
      path: '/image',
      name: 'image',
      meta: {
        menu: '/image',
        keep: true  // 缓存
      },
      component: resolve => require(['@/pages/image'], resolve)
    },
    {
      // 影像管理——更改
      path: '/imageUpdate/:step',
      name: 'imageUpdate',
      meta: {
        menu: '/image'
      },
      component: resolve => require(['@/pages/image/detail'], resolve)
    },
    /** *********** 相同页面，路径要区分开，方便后端管理每个页面的权限 *********** **/
    /** *********** 保单赔付，start, *********** **/
    {
      // 理算-保单赔付
      path: '/adjustment/policyloss',
      name: 'adjustment-policyloss',
      meta: {
        menu: '/adjustment'
      },
      component: resolve => require(['@/pages/policyLoss'], resolve)
    },
    {
      // 理算-既往赔付-保单赔付
      path: '/adjustment/beforePay/policyloss',
      name: 'adjustment-beforePay-policyloss',
      meta: {
        menu: '/adjustment'
      },
      component: resolve => require(['@/pages/policyLoss'], resolve)
    },
    {
      // 签批-保单赔付
      path: '/sign/policyloss',
      name: 'sign-policyloss',
      meta: {
        menu: '/sign'
      },
      component: resolve => require(['@/pages/policyLoss'], resolve)
    },
    {
      // 签批-既往赔付-保单赔付
      path: '/sign/beforePay/policyloss',
      name: 'sign-beforePay-policyloss',
      meta: {
        menu: '/sign'
      },
      component: resolve => require(['@/pages/policyLoss'], resolve)
    },
    {
      // 理賠查詢-保单赔付
      path: '/claim/policyloss',
      name: 'claim-policyloss',
      meta: {
        menu: '/claim'
      },
      component: resolve => require(['@/pages/policyLoss'], resolve)
    },
    /** *********** 保单赔付，end *********** **/

    /** *********** 保单详情，start *********** **/
    {
      // 报案-保单详情
      path: '/report/policyDetail',
      name: 'report-policyDetail',
      meta: { menu: '/report' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    {
      // 案件受理-保单详情
      path: '/receiving/policyDetail',
      name: 'receiving-policyDetail',
      meta: { menu: '/receiving' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    {
      // 立案-保单详情
      path: '/setup/policyDetail',
      name: 'setup-policyDetail',
      meta: { menu: '/setup' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    {
      // 理算-保单详情
      path: '/adjustment/policyDetail',
      name: 'adjustment-policyDetail',
      meta: { menu: '/adjustment' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    {
      // 签批-保单详情
      path: '/sign/policyDetail',
      name: 'sign-policyDetail',
      meta: { menu: '/sign' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    {
      // 理赔查询-保单详情
      path: '/claim/policyDetail',
      name: 'claim-policyDetail',
      meta: { menu: '/claim' },
      component: resolve => require(['@/pages/policyDetail'], resolve)
    },
    /** *********** 保单详情,  end *********** **/

    /** *********** 赔付信息，start, *********** **/
    {
      // 理算-赔付信息
      path: '/adjustment/lossInfo',
      name: 'adjustment-lossInfo',
      meta: {
        menu: '/adjustment'
      },
      component: resolve => require(['@/pages/lossInfo'], resolve)
    },
    {
      // 签批-赔付信息
      path: '/sign/lossInfo',
      name: 'sign-lossInfo',
      meta: {
        menu: '/sign'
      },
      component: resolve => require(['@/pages/lossInfo'], resolve)
    },
    /** *********** 保单赔付，end *********** **/
  ]
})

// 解决懒加载导致的找不到js的偶现问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  const targetPath = router.history.pending.fullPath
  if (isChunkLoadFailed) {
    router.replace(targetPath)
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js